var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DataGrid, } from '@mui/x-data-grid';
import { Autocomplete, Box, Button, Paper, Popover, TextField, Typography, useTheme, } from '@mui/material';
import * as React from 'react';
import { ApiServerModelsRmfApiRobotStateStatus as RobotStatus } from 'api-client';
import { robotStatusToUpperCase } from './utils';
export function RobotDataGridTable(_a) {
    var onRobotClick = _a.onRobotClick, robots = _a.robots, onRobotRecover = _a.onRobotRecover, onRobotPause = _a.onRobotPause, onRobotResume = _a.onRobotResume;
    var handleEvent = function (params, event) {
        if (onRobotClick) {
            onRobotClick(event, params.row);
        }
    };
    var Status = function (params) {
        var theme = useTheme();
        var statusLabelStyle = (function () {
            var error = {
                color: theme.palette.error.main,
            };
            var charging = {
                color: theme.palette.info.main,
            };
            var working = {
                color: theme.palette.success.main,
            };
            var defaultColor = {
                color: theme.palette.warning.main,
            };
            switch (params.row.status) {
                case RobotStatus.Error:
                    return error;
                case RobotStatus.Charging:
                    return charging;
                case RobotStatus.Working:
                    return working;
                default:
                    return defaultColor;
            }
        })();
        return (React.createElement(Box, { component: "div", sx: statusLabelStyle },
            React.createElement(Typography, { "data-testid": "status", component: "p", sx: {
                    fontWeight: 'bold',
                    fontSize: 14,
                } }, robotStatusToUpperCase(params.row.status))));
    };
    var actionCellStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    };
    var Action = function (params) {
        return (React.createElement("div", { style: actionCellStyle, onClick: function (ev) {
                ev.stopPropagation();
                ev.preventDefault();
            } },
            React.createElement(Button, { "aria-label": "Pause robot", color: "error", variant: "outlined", size: "small", onClick: function (ev) {
                    return onRobotPause &&
                        onRobotPause(ev, params.row.name);
                } }, "Pause"),
            React.createElement(Button, { "aria-label": "Resume robot", color: "success", variant: "outlined", size: "small", onClick: function (ev) {
                    return onRobotResume &&
                        onRobotResume(ev, params.row.name);
                } }, "Resume"),
            React.createElement(RobotRecovery, { onRobotRecover: function (_ev, blockName) {
                    return onRobotRecover && onRobotRecover(_ev, params.row.name, blockName);
                } })));
    };
    var columns = [
        {
            field: 'name',
            headerName: 'Name',
            width: 250,
            editable: false,
            valueGetter: function (params) { return params.row.name; },
            flex: 2,
            filterable: true,
        },
        {
            field: 'fleet',
            headerName: 'Fleet',
            width: 90,
            valueGetter: function (params) { return params.row.fleet; },
            flex: 1,
            filterable: true,
        },
        // {
        //   field: 'estFinishTime',
        //   headerName: 'Est. Task Finish Time',
        //   width: 150,
        //   editable: false,
        //   valueGetter: (params: GridValueGetterParams) =>
        //     params.row.estFinishTime ? new Date(params.row.estFinishTime).toLocaleString() : '-',
        //   flex: 1,
        //   filterable: true,
        // },
        {
            field: 'level',
            headerName: 'Level',
            width: 150,
            editable: false,
            valueGetter: function (params) { return params.row.level; },
            flex: 1,
            filterable: true,
        },
        {
            field: 'battery',
            headerName: 'Battery',
            width: 90,
            editable: false,
            valueGetter: function (params) { return "".concat(params.row.battery * 100, "%"); },
            flex: 0.5,
            filterable: true,
        },
        // {
        //   field: 'lastUpdateTime',
        //   headerName: 'Last Updated',
        //   width: 150,
        //   editable: false,
        //   valueGetter: (params: GridValueGetterParams) =>
        //     params.row.lastUpdateTime ? new Date(params.row.lastUpdateTime).toLocaleString() : '-',
        //   flex: 1,
        //   filterable: true,
        // },
        {
            field: 'status',
            headerName: 'Status',
            editable: false,
            flex: 1,
            renderCell: Status,
            filterable: true,
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 420,
            editable: false,
            flex: 2,
            renderCell: Action,
            filterable: false,
        },
    ];
    return (React.createElement(DataGrid, { autoHeight: true, getRowId: function (r) { return r.name; }, rows: robots, pageSize: 5, rowHeight: 38, columns: columns, rowsPerPageOptions: [5], onRowClick: handleEvent, initialState: {
            sorting: {
                sortModel: [{ field: 'name', sort: 'asc' }],
            },
        }, disableVirtualization: true }));
}
function RobotRecovery(_a) {
    var onRobotRecover = _a.onRobotRecover;
    var _b = React.useState(''), recoverBlock = _b[0], setRecoverBlock = _b[1];
    var _c = React.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var blockNames = [
        'Stop',
        'Block 10 Recovery',
        'Block 20e Recovery',
        'Block 20w Recovery',
        'Block 30 Recovery',
        'Block 50 Recovery',
        'Block 80 Recovery',
    ];
    var handleRecover = function (event, blockName) {
        onRobotRecover && onRobotRecover(event, blockName);
        setAnchorEl(null);
    };
    var handleOpen = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "aria-label": "Recover AMR", "aria-describedby": open ? 'recovery-popover' : undefined, "aria-haspopup": "true", color: "primary", variant: "outlined", size: "small", onClick: handleOpen }, "Recover"),
        React.createElement(Popover, { id: "recovery-popover", open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } },
            React.createElement(Paper, { elevation: 0, sx: { p: 2, display: 'flex', flexDirection: 'column', gap: 2 }, onClick: function (ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                } },
                React.createElement(Autocomplete, { id: "recovery-input", freeSolo: true, size: "small", sx: { minWidth: 200 }, options: blockNames, value: recoverBlock, onChange: function (_ev, newValue) {
                        setRecoverBlock(newValue !== null && newValue !== void 0 ? newValue : '');
                    }, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { label: "Block", required: true })); } }),
                React.createElement(Button, { id: "amr-recover-button", "aria-label": "Recover AMR", color: "primary", variant: "contained", size: "medium", onClick: function (ev) {
                        return handleRecover(ev, recoverBlock);
                    } }, "Send")))));
}
